import { MyRacesIcon, RaceWizardIcon, WatchIcon, JoinRacesIcon } from '../components/Icons';

export const NAVIGATION = [
  {
    to: '/join-races',
    icon: <JoinRacesIcon className="h-5 w-5 stroke-current" />,
    text: 'Join Races',
  },
  {
    to: '/race-wizard',
    icon: <RaceWizardIcon className="h-5 w-5 stroke-current" />,
    text: 'Race Wizard',
  },
  {
    to: '/watch',
    icon: <WatchIcon className="h-5 w-5 fill-current stroke-current" />,
    text: 'Watch',
  },
  {
    to: '/my-races',
    icon: <MyRacesIcon className="h-5 w-5 fill-current stroke-current" />,
    text: 'My Races',
  },
];
